/** JSON-LD for /careers — kept out of the page module for code splitting. */
export const BREADCRUMB_LD = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://lohalink.in/" },
    { "@type": "ListItem", "position": 2, "name": "Careers", "item": "https://lohalink.in/careers" }
  ]
};
